"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "help-rulebooks-container" };
const _hoisted_2 = { class: "help-rulebooks-section" };
const _hoisted_3 = { class: "help-icons-section-heading" };
const _hoisted_4 = { class: "help-rulebook-rows" };
const _hoisted_5 = ["href"];
const _hoisted_6 = { class: "help-rulebooks-section" };
const _hoisted_7 = { class: "help-icons-section-heading" };
const _hoisted_8 = { class: "help-rulebook-rows" };
const _hoisted_9 = ["href"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [
                    (0, vue_1.createTextVNode)("Official Expansions", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            (0, vue_1.createElementVNode)("div", _hoisted_4, [
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.officialExpansions, (entry) => {
                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                        key: entry.module,
                        href: entry.url,
                        class: "help-rulebook-row",
                        target: "_blank"
                    }, [
                        (0, vue_1.createElementVNode)("div", {
                            class: (0, vue_1.normalizeClass)(`create-game-expansion-icon expansion-icon-${entry.iconClass}`)
                        }, null, 2),
                        (0, vue_1.createTextVNode)(" " + (0, vue_1.toDisplayString)(entry.name), 1)
                    ], 8, _hoisted_5));
                }), 128))
            ])
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_6, [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_7, [...(_cache[1] || (_cache[1] = [
                    (0, vue_1.createTextVNode)("Fan Expansions", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            (0, vue_1.createElementVNode)("div", _hoisted_8, [
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.fanExpansions, (entry) => {
                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                        key: entry.module,
                        href: entry.url,
                        class: "help-rulebook-row",
                        target: "_blank"
                    }, [
                        (0, vue_1.createElementVNode)("div", {
                            class: (0, vue_1.normalizeClass)(`create-game-expansion-icon expansion-icon-${entry.iconClass}`)
                        }, null, 2),
                        (0, vue_1.createTextVNode)(" " + (0, vue_1.toDisplayString)(entry.name), 1)
                    ], 8, _hoisted_9));
                }), 128))
            ])
        ])
    ]));
}
